<template>
  <section
    v-if="showEntry"
    :key="entry._id"
    :class="`entry entry--${entry.mode} ${entry.mode} content-visibility-entry`"
    :data-id="entry._id"
    :data-signature="entry.signature"
    :data-question-result="entry.metadata.question_result || null"
    :data-question-result-title="entry.metadata.question_result_title || null"
  >
    <!--entry title -->
    <h2 v-if="entry.title" class="text-xl leading-24 sm:text-22 sm:leading-32 min-h-6 font-bold mb-4">
      <a
        v-if="entry.metadata.title_url"
        :href="entry.metadata.title_url"
        target="_blank"
        rel="nofollow"
        data-trckimg="https://t.oned.io/onedio-inline-link.img"
      >
        {{ entry.title }}
      </a>
      <template v-else>{{ entry.title }}</template>
    </h2>
    <EntryVariantText v-if="entry.mode === 'text'" :entry="entry" />
    <EntryVariantImage v-if="entry.mode === 'image'" :entry="entry" />
    <EntryVariantOnedioEmbed v-if="entry.mode === 'oio-embed'" :entry="entry" />
    <EntryVariantEmbed v-if="entry.mode === 'embed'" :entry="entry" />
    <EntryVariantHtmlLazy v-if="entry.mode === 'html' && isHTMLLazyLoad" :entry="entry" />
    <EntryVariantHtml v-if="entry.mode === 'html' && !isHTMLLazyLoad" :entry="entry" />
    <EntryVariantVideo v-if="entry.mode === 'video'" :entry="entry" />
    <EntryVariantQuiz v-if="entry.mode === 'question'" :entry="entry" />
    <PromotionButton v-if="showPromotionButton" :data="entry.metadata" />
  </section>
</template>
<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { hydrateWhenVisible } from 'vue-lazy-hydration';
import EntryVariantHtml from './EntryVariantHtml';
import PromotionButton from './PromotionButton';
import EntryVariantQuiz from '~/modules/quiz/components/EntryQuestion';

const rootMargin = '100px';
export default defineComponent({
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  components: {
    EntryVariantText: hydrateWhenVisible(() => import(/* webpackChunkName: "EntryVariantText" */ './EntryVariantText'), { rootMargin }),
    EntryVariantImage: hydrateWhenVisible(() => import(/* webpackChunkName: "EntryVariantImage" */ './EntryVariantImage'), { rootMargin }),
    EntryVariantOnedioEmbed: hydrateWhenVisible(
      () => import(/* webpackChunkName: "EntryVariantOnedioEmbed" */ './EntryVariantOnedioEmbed'),
      { rootMargin }
    ),
    EntryVariantEmbed: hydrateWhenVisible(() => import(/* webpackChunkName: "EntryVariantEmbed" */ './EntryVariantEmbed'), { rootMargin }),
    EntryVariantHtmlLazy: hydrateWhenVisible(() => import(/* webpackChunkName: "EntryVariantHtml" */ './EntryVariantHtml'), { rootMargin }),
    EntryVariantHtml,
    EntryVariantVideo: hydrateWhenVisible(() => import(/* webpackChunkName: "EntryVariantVideo" */ './EntryVariantVideo'), { rootMargin }),
    EntryVariantQuiz,
    PromotionButton,
  },
  setup(props) {
    const showEntry = computed(() => (props.entry.mode === 'html' ? !!props.entry.embedData?.html : true));
    const lazyloadThirdPartyScripts = ['twitter.com', 'youtube.com', 'tiktok.com', 'dio.onedio.com'];
    const isHTMLLazyLoad = computed(() => lazyloadThirdPartyScripts.some((script) => props.entry.embedData.html?.includes(script)));
    const showPromotionButton = computed(() => props.entry.metadata.product_url || props.entry.metadata.product_source);
    return { isHTMLLazyLoad, showEntry, showPromotionButton };
  },
});
</script>

<style lang="scss">
.content-visibility-entry {
  contain-intrinsic-size: 100px 500px;
  content-visibility: auto;
  @include sm() {
    content-visibility: visible;
  }
}
</style>
